import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError, EMPTY } from 'rxjs';
import { STORAGE_KEYS } from '../constants/storage.constants';
import { AuthDataService } from '../services/data-access/auth-data.service';
import { environment } from '@env/global';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authData = inject(AuthDataService);

  let token: string | null = null;

  try {
    token = sessionStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  } catch {
    // Storage access might fail in restricted environments
  }

  let headers = req.headers;

  if (token && (req.url.includes(environment.baseAPI) || !req.url.startsWith('http'))) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  const clonedReq = req.clone({ headers });

  return next(clonedReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // If 401 happened on login attempt, allow error to pass through so login screen can show "Invalid credentials"
        if (req.url.includes('/login') || req.url.includes('/validate-login-otp')) {
          return throwError(() => error);
        }

        // On authenticated request 401 (expired/invalid token):
        // 1. Clear session memory & storage
        authData.clearSession();

        // 2. Redirect back to login page
        router.navigate(['/auth/login'], {
          queryParams: { sessionExpired: 'true' },
        });

        // 3. Complete silently so downstream components do not show redundant error toasts
        return EMPTY;
      }
      return throwError(() => error);
    })
  );
};
